import React, { useRef, useState, useEffect } from "react";
import useCustomFormValidation from "../hooks/ErrorHandling/useCustomFormValidation";
import { FORGET_PASS_URL } from "../utils/constants";
//import { useNavigate } from 'react-router-dom';
import FooterFixed from "./FooterFixed";
import MuiLoader from "./GlobalFeature/Loader/MuiLoader";
import { pushAlert } from "../utils/alertSlice";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../utils/loaderSlice";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as LeftSideArrowIcon } from "../assets/images/icons/LeftSideArrowIcon.svg";
import ZinancialLogo from "../assets/images/ZinancialLogo.webp";
import Footer from "./Footer";

const validationRules = {
  email: [
    {
      required: true,
      errorMessage: "Cannot be left blank",
    },
    {
      email: true,
      errorMessage: "Provide valid email",
    },
  ],
};

const ForgetPass = () => {
  //const Navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setErrors] = useState(false);
  const [reserror, setResErrors] = useState(false);
  const [succesmsg, setSuccErrors] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [ticker, setTicker] = useState(0);

  const navigate = useNavigate();

  const password = useRef(null);
  const password_confirmd = useRef(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const [formData, setFormData] = useState({
    email: "",
  });

  const { values, errors, touched, handleChange, validateField, isFormValid } = useCustomFormValidation(
    formData,
    validationRules
  );

  const handleInputChange = (event) => {
    handleChange(event);
    const { name, value } = event.target;
    setInputValue(value);
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  // const handleButtomClick = async (event) => {
  //   event.preventDefault();
  //   const formValid = isFormValid();
  //   if (formValid === true && formData !== "") {
  //     try {
  //       const response = await fetch(FORGET_PASS_URL, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(formData),
  //       });
  //       const data = await response.json();
  //       if (data.status == "success") {
  //         setSuccErrors(data.message);
  //         setInputValue("");
  //       }
  //       if (data.status == "error") {
  //         setResErrors(data.message);
  //         //setFormData('');
  //       }
  //       //console.warn(data,"data here now")
  //     } catch (error) {
  //       console.error("Error:", error);
  //       setErrorMessage("An error occurred. Please try again.");
  //     }
  //   }
  // };

  const handleButtomClick = async (event) => {
    event.preventDefault();
    const formValid = isFormValid();

    if (!formValid) return;
    setTicker(30);
    try {
      // setLoading(true);
      // setLoading(true);
      const response = await fetch(FORGET_PASS_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.status === "success") {
        // setSuccErrors(data.message);
        setInputValue("");
        setLoading(false);
        dispatch(pushAlert({ type: "success", message: data.message, visible: true }));
        navigate("/authentication", { state: { signupData: formData, authType: "password" } });
      }
      if (data.status == "error") {
        setResErrors(data.message);
        //setFormData('');
        setLoading(false);
        dispatch(pushAlert({ type: "danger", message: data.message, visible: true }));
      }
      dispatch(pushAlert({ type: "success", message: data.message, visible: true }));
      setLoading(false);
      navigate("/authentication", { state: { signupData: formData, authType: "password" } });
    } catch (error) {
      // console.error("Error:", error);
      setErrorMessage("An error occurred. Please try again.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let timer;
    timer = setInterval(() => {
      if (ticker > 0) setTicker((prevTick) => prevTick - 1);
    }, 1000);
    if (loading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
    return () => clearTimeout(timer);
  }, [loading]);

  const handleClick = () => {
    navigate("/");
  };

  return (
    <div className="bg-white h-screen flex flex-col">
      <Link to="/" className="w-40 p-4 cursor-pointer ">
        <img src={ZinancialLogo} alt="Zinancial Logo" />
      </Link>
      <Link to="/" className="w-40 px-4 cursor-pointer ">
        <button className="flex  bg-F4F4F4 border border-EAE2E2 rounded-lg py-2  px-5 gap-4 items-center">
          <LeftSideArrowIcon />
          <span className="text-[#535252] text-lg font-medium">BACK</span>
        </button>
      </Link>
      <div className="flex items-center justify-center grow min-h-0">
        <div className="px-5 py-14 border-[#EDEDED] border rounded mx-28 w-[32rem] max-w-xl stroke-[#EDEDED]  stroke-1 shadow">
          <div className="text-1D5D9B text-24 font-bold  px-4 text-center">Forget Password</div>
          <div className="h-8 text-center">
            {/* {succesmsg && <span className="mt-1 text-green-500 font-normal text-14">{succesmsg}</span>} */}
          </div>
          <div className="space-y-5">
            <form onSubmit={(e) => e.preventDefault()} className="flex flex-col py-2 px-5" id="ResetPassForm">
              <label htmlFor="email" className="text-545B61 text-14 font-500">
                Email
              </label>
              <input
                className="border-1 border-E4EDF3 rounded-md focus:outline outline-1D5D9B focus:border-sky-700 w-full px-1"
                type="email"
                name="email"
                id="email"
                placeholder=""
                value={inputValue}
                onChange={handleInputChange}
              />
              <div className="h-8">
                {(errors.email && <span className="text-red-500 font-normal text-12">{errors.email}</span>) ||
                  (reserror && <span className="text-red-500 font-normal text-12">{reserror}</span>)}
              </div>

              <button
                onClick={handleButtomClick}
                type="submit"
                className={`bg-sky-700 w-full text-white font-bold py-1 rounded-md mb-3 hover:bg-sky-600 ${ticker > 0 || Boolean(errors.email?.length) ? "opacity-50 cursor-not-allowed" : ""}`}
                disabled={ticker > 0 || Boolean(errors.email?.length)}
              >
                Submit
              </button>
              {ticker > 0 && (
                <div className="text-center text-red-500 font-normal text-12">
                  Please wait <b>{ticker}</b> seconds before resending the email.
                </div>
              )}
            </form>
            <div className="flex items-center">
              <hr className="h-[1px] w-full bg-EDEDED" />
            </div>
            <div className="text-center text-545B61 text-lg font-normal">
              Don't have an account yet?{" "}
              <a href="/signup" className="font-bold text-[#F16136] text-lg">
                Sign Up now.
              </a>
            </div>
            <div className="text-center text-545B61 text-lg font-normal">
              By continuing, you are indicating that you have read and agree to the
              <a className="text-[#1D5D9B] text-lg font-bold"> Terms of Use</a> and{" "}
              <a className="text-[#1D5D9B] text-lg font-bold">Privacy Policy.</a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ForgetPass;
